export enum ResultStatus {
  OK = 'OK',
  ERROR = 'ERROR',
}
